import { Api, IConfig } from '@estee/elc-service';
import { IEmailOptIn } from '../internal/domain/entities/EmailOptIn';

const { name, version } = __serviceInfo__;
export interface IEmailOptInRequest {
    emailAddress: string;
    subscribeSource: string;
    communicationType: string[];
}

export class CommunicationsApiSdk extends Api {
    private backInStockUrl: string;
    private emailOptInUrl: string;

    constructor(config: IConfig) {
        super(config, name, version);
        this.backInStockUrl = '/stardust-communications-backinstock-v0/subscribers';
        this.emailOptInUrl = '/stardust-communications-subscriptions-v0/subscriptions';
    }

    public subscribeToBackInStockNotification = async (
        skuId: string,
        emailAddress: string,
        subscriptionType: string
    ) => {
        await this.post({
            url: this.backInStockUrl,
            body: {
                skuId,
                emailAddress,
                subscriptionType
            }
        });
    };

    public emailOptInRequest = async (payload: IEmailOptInRequest) => {
        const response = await this.post<IEmailOptIn[]>({
            url: this.emailOptInUrl,
            body: payload
        });

        return response.data;
    };

    public getEmailOptInRequest = async (email: string) => {
        const response = await this.get<IEmailOptIn[]>(
            `${this.emailOptInUrl}?emailAddress=${email}`
        );

        return response.data;
    };

    public updateEmailOptInRequest = async (subscriptionId: string, payload: {}) => {
        const response = await this.patch({
            url: `${this.emailOptInUrl}/${subscriptionId}`,
            body: payload
        });

        return response.data;
    };
}
